// extracted by mini-css-extract-plugin
export default {"tips":"Tips_tips__ny9ma","icon":"Tips_icon__MiAQl"};